<app-dashboard-layout [pageTitle]="''" [hasAction]="false"
    (onNotificationClick)="{}" (onAction)="{}">
    <div pageContent>
        <app-simple-payment-form></app-simple-payment-form>
    </div>
</app-dashboard-layout>
